<template>
  <div class="body">
    <v-container fluid>
      <v-row justify="center">
        <v-col sm="12" md="6" style="align-self: center">
          <div style="width: 75% !important; margin: auto; align-self: center">
            <h1 class="text-left text-uppercase mb-16" style="color: var(--v-darkGreen-base)">Zaslat znovu aktivační email</h1>
            <v-alert v-if="requestSuccess" color="success">E-mail byl úspěšně odeslán.</v-alert>
            <v-alert v-if="requestError" color="error">{{ errorMessage }}</v-alert>
            <v-form v-model="formValid" ref="form" @submit.prevent>
              <label>Vložte prosím svůj e-mail</label>
              <v-text-field
                placeholder="INFO@VASEDOMENA.CZ"
                outlined
                class="rounded-lg"
                v-model="email"
                :rules="[rules.required, rules.email]"
              ></v-text-field>
              <v-btn
                :disabled="!formValid || wait"
                @click="resetPass"
                color="lightGreen"
                class="mr-4 text-uppercase py-8 mb-5"
                style="width: 100%; color: white !important;"
              >Zaslat znovu</v-btn>
            </v-form>
            <div class="mb-5 text-center" style="align-items: baseline">Nemáte účet? <router-link :to="{name: 'register'}" class="pl-2"> Zaregistrujte se</router-link> <br class="d-flex"> <span class="px-2">nebo</span> <router-link :to="{name: 'quick-register'}">Rychlá registrace</router-link><br><br><router-link to="/">Zpět na přihlášení</router-link></div>
          </div>
        </v-col>
        <v-col xs="0" sm="0" md="6" class="d-none d-sm-flex">
          <v-img src="@/assets/loginimg.jpg" class="rounded-xl" id="loginimg"></v-img>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import rules from '@/mixins/rules'

export default {
  name: 'ResendActivationEmail',
  mixins: [rules],
  data () {
    return {
      requestSuccess: false,
      errorMessage: '',
      requestError: false,
      wait: false,
      formValid: true,
      email: ''
    }
  },
  methods: {
    resetPass () {
      this.wait = true
      this.requestSuccess = false
      this.requestError = false
      this.$http.post('email/resend', {
        email: this.email
      })
        .then(res => {
          this.wait = false
          this.requestSuccess = true
          this.$refs.form.reset()
        })
        .catch(err => {
          if (err.response.data.message === 'Already verified') {
            this.errorMessage = 'E-mail je již verifikován'
          } else {
            this.errorMessage = 'E-mail se nepodařilo odeslat.'
          }
          this.wait = false
          this.requestError = true
        })
    }
  }
}
</script>

<style scoped>
#loginimg{
  height: 95vh;
}
.body{
  background-color: #f9f9fb !important;
  height: 100vh;
}
a{
  color: var(--v-lightGreen-base) !important;
  text-decoration: none;
  font-size: 0.9em;
}
.container{
  font-family: 'Readex Pro', sans-serif !important;
}
h1{
  font-family: 'Poppins', sans-serif;
}
label{
  color: black;
  font-weight: 500;
}
>>>.v-input__slot{
  background-color: white !important;
}
>>>input::placeholder {
  font-weight: 500 !important;
}
>>>.theme--light.v-input input, >>>.theme--light.v-input textarea{
  color: var(--v-darkGreen-base) !important;
}
</style>
